import { LICENSE_STATUS } from '../constants/license';

export default {
  translation: {
    general: {
      today: 'Today',
      loading: 'Loading...'
    },
    header: {
      users: 'Users',
      quiz: 'Test',
      questions: 'Questions',
      statistics: 'Statistics',
      coachAI: 'Edulai Coach AI',
      skills: 'Skills & Sub-Skills',
      settings: 'Settings',
      domain: 'Domain Info'
    },
    skills: {
      COLLABORATION: 'Collaboration',
      CRITICAL_THINKING: 'Critical Thinking',
      PROBLEM_SOLVING: 'Problem Solving',
      LEADERSHIP: 'Leadership',
      COMMUNICATION: 'Communication',
      INTERCULTURALISM: 'Interculturalism',
      LEARNING: 'Learning',
      systemSkills: "System's Skills",
      createNewSkill: 'New Skill',
      noSkillFound: 'No Skill found in the system',
      systemSubSkill: 'Sub-Skill',
      systemSubSkills: 'Sub-Skills',
      noSubSkillForSkill: 'No Sub-Skill defined for the selected skill',
      systemSubSkillsDescription: 'Define one or more Sub-Skills associated with the current Skill'
    },
    skillsReport: {
      reportIntroductionTitle: 'Introduction',
      reportIntroduction:
        "Edulai Skills Checker© is a software from the Edulai package designed to measure users' skills through the administration of specific professional cases.\n\nThe purpose of Edulai Skills Checker© is to evaluate the level of transversal skills and sub-skills on a scale from 1 (basic) to 5 (expert), which are key tools for the future job market.\n\nThe Skills Checker© presents professional cases that the user must solve by choosing aresponse from various possible options, reflecting on behaviors that may be closer to their personal experience or that the user chooses to implement to solve new problems.\n\n",
      reportSkillsListIntro: 'The skills evaluated by this test are as follows:',
      reportSkillsValueListIntro:
        'The scale used for the evaluation includes the following levels/stars for each skill:',
      reportIntroductionEnd:
        "Once the evaluation is completed, the system provides access to a guide manual for reading one's results and the definitions of the skills.",
      reportIntroductionSkillsValue:
        '• 1 star – Basic\n• 2 stars – Beginner\n• 3 stars – Intermediate\n• 4 stars – Advanced\n• 5 stars – Expert',
      skillsResultsTitle: 'SKILLS CHECKER RESULTS FOR EACH SKILL & SUB-SKILL',
      skillsChartResultsTitle: 'SKILLS CHECKER RESULTS',
      skillsResultsValueTitle: 'REFERENCE VALUE (1-5)',
      strengths: 'Strengths',
      weaknesses: 'Weaknesses',
      areasDevelopments: 'Areas of developments',
      noWeaknesses: 'Currently the report does not show skills to improve to discuss.',
      noStrengths: 'Currently the report does not show high level skills to discuss.',
      noAreasDevelopments: 'Currently the report does not show areas of developments.'
    },
    login: {
      noService: 'Service temporary not available. Please reload the page to retry',
      welcome: 'Welcome back',
      passwordRecovery: 'Forgot your password?',
      passwordRecoveryBody: 'Enter your email below. We will send you and email with a link to reset your password',
      loginError: 'Login error. Please check your credentials and try again',
      welcomeFirstTime: 'Set your password to access',
      confirmRegistrationError: 'An error occurred while creating your account. Please try again',
      creatingYourAccount: 'We are creating your new account!',
      createAccountSuccess: 'Account created successfully! Check your email to set your password and login',
      resetPasswordSuccess: 'An email with password recovery instructions has been send!',
      resetPasswordError: 'An error occurred on the password recovery. Please try again',
      passwordSetSuccess: 'Password set successfully!',
      passwordSetError: 'An error occurred while creating the new password. Please try again',
      insertEmail: 'Your email',
      insertPassword: 'Your password',
      registerNow: 'No account yet? Register now!',
      registerUserBody: 'Insert your data to create your Edulai account!',
      registerUserEmail: 'We will send you and email with the instructions to set your password',
      createNewAccount: 'Create a new account',
      acceptPrivacy: "I've read and accept the Privacy Policy",
      passwordRecoveryForUser: 'Send password recovery email'
    },
    modals: {
      cancel: 'Cancel',
      continue: 'Continue',
      confirm: 'Confirm',
      ok: 'Ok',
      compliment: 'Congratulations!',
      publish: 'Publish',
      close: 'Close',
      delete: 'Delete',
      save: 'Save',
      reloadPage: 'Reload Page',
      closeWithoutSave: 'Close without saving'
    },
    languages: {
      language: 'Language',
      it: 'Italian',
      en: 'English',
      ITALIAN: 'Italian',
      ENGLISH: 'English',
      selectLanguage: 'Select a language'
    },
    user: {
      profile: 'Profile',
      ageRange: 'Age',
      gender: 'Gender',
      nation: 'Nation',
      employment: 'Employment',
      professionName: 'Profession',
      experienceAgeRange: 'Years of experience',
      educational: 'Educational level',
      portfolioDescription: 'Portfolio',
      employmentsTypes: {
        STUDENT: 'Student',
        UNEMPLOYED: 'Unemployed',
        EMPLOYED: 'Employed'
      },
      ageRangeTypes: {
        RANGE18_22: '18-22 years',
        RANGE23_25: '23-25 years',
        RANGE26_30: '26-30 years',
        RANGE31_40: '31-40 years',
        RANGE41_50: '41-50 years',
        RANGE51_99: '50+'
      },
      experienceAgeRangeTypes: {
        RANGE0_1: 'Less than one year',
        RANGE1_2: '1-2 years',
        RANGE2_5: '2-5 years',
        RANGE5_10: '5-10 years',
        RANGE10_20: '10-20 years',
        RANGE20_99: 'More than 20 years'
      },
      genderTypes: {
        MALE: 'Male',
        FEMALE: 'Female',
        UNSPECIFIED: 'Unspecified'
      },
      educationalTypes: {
        SECONDARY_SCHOOL: 'High school',
        GRADUATION: 'University degree',
        POSTGRADUATE_CERTIFICATE: 'Post-university certification'
      },
      onboardingUpdatedAt: 'Profile updated at {{date}}'
    },
    forms: {
      copySuccess: 'Link copied on clipboard',
      inactiveUserActivationLink: 'Activation Link',
      inactiveUserExplanation: 'User has not yet activate his account',
      inactiveUserCopyLink: 'If the user has difficulty activating his account, you can send him this activation link',
      inactiveUserCopyWarning:
        'Warning: use this link only in cases of extreme necessity. Check that the user has entered a valid email and that he is sending the link to the correct account. Once in possession of the activation link, anyone can also activate this account incorrectly',
      selectSkill: 'Select a skill',
      today: 'Today',
      thisMonth: 'This month',
      thisYear: 'This year',
      last6Months: 'Last 6 months',
      thisWeek: 'This week',
      edulaiTagNotModify: 'The Edulai group cannot be modified',
      tagName: 'Group name',
      selectAtLeastOneSkillToCreateAnswers: 'Select at least one Skill and one Sub-Skill to start creating answers',
      forceUserOnboardingDescription: 'Force user to take onboarding again',
      forceUserOnboarding: 'Force onboarding',
      newSubSkill: 'New Sub-Skill',
      selfAssessmentDescription:
        'For each skill indicate your mastery level with a value from 1 to 5, where 1 indicates the basic level and 5 the Expert level',
      saveDraft: 'Save test draft',
      backtoLogin: 'Back to Login',
      noOptions: 'No options',
      loadingOptions: 'Loading options',
      companyRolePlaceholder: 'Search role...',
      companyLicensePlaceholder: 'Search license...',
      required: 'Required',
      save: 'Save',
      search: 'Search',
      reset: 'Reset',
      name: 'Name',
      edit: 'Edit',
      send: 'Send',
      createNew: 'Create new',
      saveChanges: 'Save changes',
      firstName: 'Name',
      lastName: 'Last name',
      address: 'Address',
      next: 'Next',
      back: 'Back',
      skip: 'Skip',
      finish: 'Finish',
      optional: 'Optional',
      confirmPassword: 'Confirm password',
      newPassword: 'Create your password',
      passwordValidation: 'Minimum 8 characters a letter and do not use special characters',
      passwordMustCoincide: 'Password must coincide',
      passwordSpecialCharacters: 'NO special characters',
      warning: 'Warning',
      confirm: 'Confirm',
      close: 'Close',
      bio: 'Bio',
      emailNotValid: 'Email not valid',
      logoutConfirmation: 'Are you sure you want to logout?',
      iAcceptThe: "I've read and accept the",
      privacyPolicy: 'Privacy Policy',
      confirmPasswordLabel: 'Confirm your password',
      confirmRegistration: 'Create your account',
      confirmPasswordTitle: 'Confirm password',
      userRole: 'User role',
      userLicense: 'User License',
      deleteUser: 'Delete user',
      disableUserExplanation: 'Disable the user to revoke all the priviliges in the institution',
      userStatus: 'User status',
      enabledUserExplanation: 'The user has been disabled',
      onboardingTitle: 'Welcome to Edulai!',
      onboardingDescription:
        "We welcome you to <strong>Edulai Skills Checker</strong>. Before we start, we kindly ask you to take a couple of minutes to let us get to know you better. How do you evaluate your skills? Take your time to answer and be honest with yourself. Let's get started now.",
      whatIsYourAge: 'How old are you?',
      startEdulai: 'Start using Edulai!',
      whatIsYourGender: "What's your gender?",
      male: 'Male',
      female: 'Female',
      other: 'Other',
      insertNation: 'Insert your nation',
      whatIsYourNation: "What's your nation?",
      whatIsYourOccupancy: 'You are currently',
      student: 'Student',
      unemployed: 'Unemployed',
      professionist: 'Employed professionist',
      whatIsYourJob: 'If you are employed, what is the name of your main professional role?',
      insertJobTitle: 'Enter the name of your role',
      yearsOfExperince: 'How many years of professional experience you have in that role?',
      insertYearsOfExperince: 'Insert your years of experience',
      years: 'Years',
      lessThanOneYear: 'Less then 1 year',
      moreThanTwentiYear: 'More than 20 years',
      whatIsYourScholarLevel: 'What is your school level?',
      highSchool: 'High school',
      universityDegree: 'University degree',
      postUniversityDegree: 'Post-university certification',
      stageOrInsterests:
        'Have you ever done internships of any kind, studies or work abroad, or do you have personal interests that have helped you develop skills for the job market? If yes, select the skills you have gained and explain below which experiences have been acquired. If applicable, you can discuss these skills directly with employers',
      stageOrInsterestsSupport:
        'Cross this box if you have material produced to support the skills you have listed above, as part of your professional portfolio to show to employers and indicate what material it is (e.g. video recordings of your presentations, written works or projects you made, etc)',
      stageOrInsterestsBadges:
        'Have you ever obtained digital badges for one or more of the above skills? If so, does it indicate for which competences you have gained them? Please also provide the link to badges',
      skillName: 'Skill name',
      newSkillWarning:
        'The new skill will only be available for creating or editing new questions. The changes will not involve Test already created or in progress',
      skillCreatedSuccess: 'Skill created successfully',
      skillCreatedError: 'An error occurred while creating the skill. Please try again',
      skillUpdatedSuccess: 'Skill updated successfully',
      skillUpdatedError: 'An error occurred while updating the skill. Please try again',
      skillDeleteWarning:
        'By deleting this skill you will make it unavailable for new tests. Previous tests including this skill will not be affected by this change and the skill will still be visibile on statistics',
      skillDeleteError: 'An error occurred while deleting this skill',
      skillDeleteSuccess: 'Skill deleted successfully',
      subSkills: 'Sub-Skills',
      subSkillDeleteWarning:
        'By deleting this Sub-Skill you will make it unavailable for new tests. Previous tests including this Sub-Skill will not be affected by this change and the Sub-Skill will still be visibile on statistics',
      subSkillCreatedSuccess: 'Sub-Skill created successfully',
      subSkillCreatedError: 'An error occurred while creating the Sub-Skill. Please try again',
      subSkillUpdatedSuccess: 'Skill updated successfully',
      subSkillUpdatedError: 'An error occurred while updating the Sub-Skill. Please try again',
      subSkillDeleteError: 'An error occurred while deleting this Sub-Skill',
      subSkillDeleteSuccess: 'Sub-Skill deleted successfully',
      deleteSubSkill: 'Delete Sub-Skill',
      deleteSkill: 'Delete Skill',
      expirationDate: 'Expiration date',
      creationDate: 'Creation date',
      credits: 'Remaining credits',
      subscriptionType: 'License type',
      addCredits: 'Add credits',
      setCredits: 'Set credits',
      totalCredits: 'Total credits',
      creditsLabel: 'Credits',
      addCreditsDescription: 'Modify the credits for the institution',
      addCreditSuccess: 'Credits modified successfully',
      addCreditError: 'An error occurred while modifying the credits. Please try again',
      modifyDomainType: 'Modify license type',
      modifyDomainTypeDescription:
        'You can change the type of domain license to Flat License (unlimited credits) and PPU License (limited credits).',
      modifyDomainTypeWarning: 'Are you sure you want to change the license?',
      modifyDomainTypeSuccess: 'License successfully modified',
      modifyDomainTypeError: 'An error occurred while changing the license. Please try again',
      flatSubscriptionDescription: 'Flat (unlimited credits)',
      ppuSubscriptionDescription: 'PPU (pay per credits)',
      flatCreditsDescription:
        'In FLAT-type domains the remaining credits will not be deducted on new tests submissions',
      domainStatus: 'Domain Status',
      disabled: 'Disabled',
      enabled: 'Active',
      disableDomain: 'Disable Domain',
      enableDomain: 'Activate Domain',
      enableUserSuccess: 'User enabled successfully',
      enableUser: 'Enable user',
      disableDomainRequest:
        'Are you sure you want to disabled the domain? It will not be possible to create new users, submit new answers and create new tests',
      modifyDomainStatusSuccess: 'Domain status modified successfully',
      modifyDomainStatusError: 'An error occurred while modifying the domain status',
      title: 'Title',
      text: 'Text',
      evaluatedSkills: 'Evaluated skills',
      startDate: 'Start date',
      startTime: 'Start time',
      startDateTime: 'Start date & time',
      endDate: 'End date',
      endTime: 'End time',
      endDateTime: 'End date & time',
      min1hr: '1 hour minimum',
      startBeforeEnd: 'Start date after end date',
      newEndBeforeOldEnd: 'New end date is before original one',
      quizInPast: "Can't create test in the past",
      delete: 'Delete',
      totals: 'Totals',
      total: 'Total',
      creditsAfterOperations: 'Credits after the operation: {{credits}}',
      selectOperation: 'Select operation',
      modifyCredits: 'Modify Credits',
      userTagPlaceholder: 'Select a group for the user',
      userTag: 'User group',
      userTagDescription: 'Use groups to allow you to easily select multiple users',
      createNewOption: 'Create new',
      createNewTagDescription: 'Create a new group for users',
      createNewTag: 'Create new group',
      modifyTagDescription: 'Modify the group of users',
      deleteTagConfirm: 'Are you sure you want to delete this group? Operation cannot be undone',
      dateInterval: 'Date interval',
      applyFilters: 'Apply filters',
      resetFilters: 'Reset filters',
      stageOrInsterestsDescription: 'Skills and experience gained on a stage',
      badgeLinksDescription: 'Digital badges links',
      edulaiTagDefaultDescription: "If you don't select a group, the user will belong to the Edulai default group",
      editSkillName: 'Edit skill name',
      cantDeleteReferencedSkill: "Can't delete skill. It's referenced by one or more questions.",
      deleteQuestionWarning:
        'By deleting this question you will make it unavailable for new tests. Previous tests including a previous version of this question will not be affected by this change',
      deleteQuestionSuccess: 'Question deleted',
      deleteQuestionError: 'An error occurred deleting the question',
      deleteQuestionInUseError: 'Error: the current version of this question is in use in a Test',
      maxCharacters: 'Max {{number}} characters'
    },
    domainTypes: {
      FLAT: 'Flat subscription',
      PPU: 'Pay per use subscription'
    },
    users: {
      inactive: 'Inactive',
      inactiveUser: 'Inactive users',
      tagUsers: 'Users',
      usersTags: 'Users groups',
      deleteTagSuccess: 'Group deleted',
      deleteTagError: 'Error while deleting the group',
      createUserTagSuccess: 'Group created',
      createUserTagError: 'Error while creating the group',
      editUserTagSuccess: 'Group modified',
      editUserTagError: 'Error while editing the group',
      userData: 'User Data',
      userProfile: 'User profile',
      platformUsers: 'Platform users',
      platformUser: 'Platform user',
      createNewUser: 'New user',
      userEmail: 'User email',
      noUsersFound: 'No user found',
      disabled: 'Disabled',
      enabled: 'Active',
      disableUser: 'Disable user',
      userModifyError: 'An error occurred while updating your data',
      userModifySuccess: 'Profile updated successfully',
      modifyUserSuccess: 'User data updated successfully',
      createUserSuccess:
        'User created successfully. The new user will be INACTIVE until it will activate its account by creating its own password',
      deleteUserConfirm: 'Are you sure to delete the selected user? The operation is not reversible.',
      resendConfirmationEmail: 'Resend confirmation email',
      resendActivationEmail: 'Send activation email',
      userAlreadyExists: 'An user with the same email already exists',
      userDeleteSuccess: 'User deleted successfully',
      disableUserSuccess: 'User disabled successfull',
      disableUserError: 'An error occurred while disabling the user. Please try again',
      newSubSkill: 'New Sub-Skill',
      activeUsers: 'Active users',
      disabledUsers: 'Disabled users',
      onboardingFailed: 'An error occurred while updating user data. Please try again'
    },
    questions: {
      newQuestion: 'New question',
      editQuestion: 'Edit question',
      findInTitle: 'Find in the title...',
      noQuestionsFound: 'No questions found',
      createQuestionSuccess: 'Question created successfully',
      createQuestionError: 'An error occurred while creating the question. Please try again',
      modifyQuestionSuccess: 'Question modified successfully',
      modifyQuestionError: 'An error occurred while modifying the question. Please try again',
      answers: 'Answers',
      newAnswer: 'New answer',
      editAnswer: 'Edit answer',
      deleteOptionConfirm: 'Are you sure to delete the selected option? The operation is not reversible.',
      optionDeleteSuccess: 'Option deleted successfully',
      optionsNumberError: 'Please, insert at least 3 valid answers.',
      firstOptionCreate:
        'After creating the first answer, editing skills and subskills will reset all the answers. Are you sure you want to proceed?',
      myAnswers: 'My answers',
      version: 'Version'
    },
    roles: {
      ROOT: 'Root',
      ADMIN: 'Admin',
      SUPERVISOR: 'Supervisor',
      USER: 'Basic user',
      PRINCIPAL: 'Principal'
    },
    license: {
      TRIAL: 'Trial',
      PRO: 'Pro'
    },
    rolesDescriptions: {
      ROOT: 'This role is dedicated to the managers of the Edulai cloud platform',
      ADMIN: 'The Admins are responsible for the platform user management and customers registry',
      PRINCIPAL: 'The Principal is the head of the institution. He can see global statistics and metrics',
      SUPERVISOR: 'Supervisors are responsible to create and manage tests',
      USER: 'Basic users can receive and submit answers to tests'
    },
    licenseDescriptions: {
      TRIAL:
        'Trial users have full access to the platform and AI features for 7 days, allowing them to explore the system’s capabilities before activating the Pro license.',
      PRO: 'Pro users have full and continuous access to all platform and AI features for the defined activation period.'
    },
    licenseTooltip: {
      [LICENSE_STATUS.EXPIRED]: 'License expired on {{formattedDate}}',
      [LICENSE_STATUS.WARNING]: 'License expiring on {{formattedDate}}'
    },
    domain: {
      customFields: 'Custom user field',
      createCustomField: 'Create custom field',
      customFieldDescription: 'This custom field will be presented as a question in the user onboarding',
      customFieldTitle: 'Custom field name',
      customFieldBody: 'Custom field question body',
      customFieldSuccess: 'Custom fields edited successfully',
      customFieldError: 'An error occurred while editing the custom fields',
      deleteCustomFieldRequest: 'Are you sure you want to delete this custom field? Operation cannot be undone',
      customFieldDeleteSuccess: 'Field deleted successfully',
      customFieldDeleteError: 'An error occurred deleting this field'
    },
    quizzes: {
      types: {
        DRAFT: 'DRAFT',
        RUNNING: 'RUNNING',
        PAUSED: 'PAUSED',
        DONE: 'DONE',
        READY: 'READY',
        ALL: 'ALL',
        EXPIRED_FOR_USER: 'EXPIRED'
      },
      typesDescriptions: {
        DRAFT: 'Drafter test can be modified until submitted',
        RUNNING: 'The test is running and users can submit their answers',
        PAUSED: 'The test is paused and users cannot submit their answers',
        DONE: 'The test is done!',
        READY: 'Test will start when its start date expire or if started explicitly',
        EXPIRED_FOR_USER: "Test is over and you haven't submit your answers"
      },
      selectSupervisor: 'Select a Supervisor',
      selectSupervisorDescription: "If you don't select a supervisor you will be responsible for this test!",
      noCreditsError: 'Domain credits expired! Please add new credits to continue',
      activeQuizzes: 'Active tests',
      disabledQuizzes: 'Disabled tests',
      newQuiz: 'New test',
      noQuizzesFound: 'No tests found',
      editQuiz: 'Edit test',
      createQuizSuccess:
        'Test successfully created. Test will remain in "Draft" state until it will be started explicitly',
      createQuizError: 'An error occurred while creating the test. Please try again',
      participants: 'Participants',
      users: 'Users',
      questions: 'Questions',
      selectedQuestionsNumber: 'Number of question selected',
      validity: 'Validity',
      completed: 'Completed',
      progress: 'Progress',
      submit: 'Submit',
      submitDraft: 'Test ready!',
      submitQuizError: 'An error occurred while submitting the test. Please try again',
      quizSubmitSuccess: 'Test submitted successfully. Quizz will remain in "Ready" state until its start date',
      pause: 'Pause',
      resume: 'Resume',
      pauseQuizError: 'An error occurred while pausing the test. Please try again',
      quizPauseSuccess: 'Test paused successfully',
      resumeQuizError: 'An error occurred while resuming the test. Please try again',
      quizResumeSuccess: 'Test resumed successfully',
      changeStartDate: 'Change start date & time',
      forceStart: 'Start now',
      newStartDateTime: 'New start date & time',
      changeStartDateError: 'An error occurred while chainging test start date & time. Please try again',
      changeStartDateSuccess: 'Start date & time changed successfully',
      confirmForceStart: 'Are you sure you want to immediately start the test?',
      forceStartError: 'An error occurred while starting the test. Please try again',
      forceStartSuccess: 'Test started successfully',
      addNewParticipants: 'Add new participants',
      newParticipants: 'New participants',
      addParticipantsSuccess: 'New participants successfully added',
      addParticipantsError: 'An error occurred while adding new participants. Please try again',
      terminate: 'Terminate',
      confirmTerminateQuiz: 'Are you sure you want to immidiately terminate the test? The action will be irreversible.',
      terminateQuizSuccess: 'Test successfully terminated',
      terminateQuizError: 'An error occurred while terminating the test. Please try again',
      editQuizSuccess:
        'Test successfully updated. Test will remain in "Draft" state until it will be started explicitly',
      editQuizError: 'An error occurred while updating the test. Please try again',
      reactivate: 'Reactivate',
      confirmReactivateQuiz: 'Are you sure you want to reactivate the test?',
      reactivateQuizSuccess: 'Test successfully reactivated',
      reactivateQuizError: 'An error occurred while reactivating the test. Please try again',
      createdBy: 'Supervisor',
      extendQuizSuccess: 'Test successfully extended',
      extendQuizError: 'An error occurred while extending the test. Please try again',
      newEndDateTime: 'New end date & time',
      extendExpiration: 'Extend expiration',
      confirmDeleteQuiz: 'Are you sure you want to immidiately delete the test? The action will be irreversible.',
      deleteQuizSuccess: 'Test successfully deleted',
      deleteQuizError: 'An error occurred while deleting the test. Please try again',
      showQuestionsDetails: 'Show questions details',
      givenAnswers: 'Answers completed',
      totalQuestions: 'Total Questions',
      quizStatistics: 'Statistics',
      userAnswers: 'Show answers',
      sendReminder: 'Send reminder',
      sendReminderSuccess: 'Reminder sent',
      sendReminderError: 'Send reminder failed',
      hideScoresToUsers: 'Hide scores to participants',
      usersCanDownloadReport: 'Users can downlaod individual report',
      hideScores: 'Hide scores',
      downloadReport: 'Download Report',
      hideScoresDescription:
        'If you hide the scores, users will be able to review their answers to the test but not their results',
      downloadReportDescription:
        'If you enable the option to download individual reports, users will be able to download their own report. However, if the ‘Hide Scores’ option is enabled, quiz participants will not be able to download their report.',
      hideScoreAnalyticsDescription: 'The test scores are hidden by the supervisor',
      updateHideScoreSuccess: 'Hide scores successfully updated',
      updateDownloadReportSuccess: 'Download report successfully updated',
      updateHideScoreError: 'An error occurred while updating hide scores. Please try again',
      updateDownloadReportError: 'An error occurred while updating download report. Please try again'
    },
    analytics: {
      userScoresAsc: 'From worst to best',
      userScoresDesc: 'From best to worst',
      valutationRange: 'Rating Range',
      order: 'Sorting',
      changeView: 'Change view',
      private: 'Private and confidential',
      userScore: 'Score for user',
      score: 'Score',
      subskillsScores: 'Subskills scores',
      skillsScores: 'Skills scores',
      analytics: 'Analytics',
      submissionsTrend: 'Submissions trend',
      usersSubmissions: 'Participants submissions',
      noSubmissionStarted: 'No submission found for this user',
      submissionStillDraft: "The user has started a submission but hasn't finalized it",
      currentScores: 'Test scores',
      selfAssessmentScores: 'Self assessment',
      userQuizSkillsScore: 'User scores for the test',
      usersQuizSkillsScore: 'User scores',
      skillsTrendChart: 'Skills trend chart',
      leastPerformingUser: 'Least performing user',
      bestPerformingUser: 'Best performing user',
      skills: 'Skills',
      all: 'All',
      errorCreateCSV: 'An error occurred while creating the CSV',
      errorCreatePDF: 'An error occurred while creating the PDF',
      chartForUser: 'Analytics for user',
      chartForUserOverTime: 'Analytics over time for user {{user}}',
      overallStatisticsForUser: 'Overall statistics of user {{user}}',
      overallAnalytics: 'System analytics',
      filters: 'Filters',
      chartMeanOverall: "Overall means of system's skills",
      chartMeanOverTime: "Overall means of system's skills in the selected time frame",
      chartForUserMean: 'Aggregate average score of user {{user}}',
      overallAnalyticsOverTime: 'System skills over time',
      overallAnalyticsOverTimeDescription: 'This chart shows the trend of the system skills in the selected time frame',
      currentScoresOfSystem: 'Current scores of all users',
      summaryDescription: 'This chart shows the system scores for all platform users for each skill',
      userSummaryScores: 'Aggregated score for every user',
      userSummaryScoresDescription: 'This chart shows for each user the average scores',
      detailedAnalytics: 'Detailed analytics',
      selectSkillForChart: 'Select a skill to see the users scores',
      usersSkillsScores: 'Users point for all skills',
      overallStatisticsForUserDescription: 'Select a user from Filters to see details',
      userSkillsScore: 'User skills scores',
      usersSkillScores: 'Users scores for {{skill}}',
      userSummaryBubbleScores: 'User percentage per score',
      userSummaryBubbleScoresDescription: 'This chart shows for every class of score the percentage of users',
      percentage: 'Percentage',
      everyone: 'All users',
      usersPercentage: 'Percentage of users',
      downloadCsvSuccess: 'Your report has been sent. Check your email in a few minutes'
    },
    submissions: {
      answer: 'Answer',
      submissionLoadFailed: 'An error occurred while loading the test',
      pleaseReload: 'Please try again.',
      submissionsFor: 'Submissions for {{quizName}}',
      closedAt: 'closed at',
      arePaused: 'are suspended.',
      waitForSupervisor: 'Waif for further instructions from the test supervisor',
      willStart: 'will start',
      soon: 'soon',
      areOpen: 'are open',
      startNewSubmission: 'start the test',
      noAnswerSelectedError: 'Please, select one of the options.',
      submitAnswer: 'Submit answer',
      concludeQuiz: 'Finish test',
      answerSubmitSuccess: 'Answer successfully submitted',
      answerSubmitError: 'An error occurred while submitting the answer. Please try again',
      quizSubmitted: 'Test submitted',
      submissionSubmitSuccess: 'Test successfully submitted',
      submissionSubmitError: 'An error occurred while closing the test. Please try again',
      sybmissionGuidelinesSmartWorking:
        "With the words “Remote Working” we refer to the possibility to carry out one's work wherever one is, regardless of his/her geographic location, even if it can mainly take place from home. This definition also includes the use of communication technologies such as PC, internet, email, video conferencing systems, for the realization of daily work tasks and for working with colleagues in virtual/online teams. (Smarter Working Guide, 2007)",
      submissionCompleted: 'You have answered all questions! Send your responses to complete the test',
      noSubmissionSendQuizDone: "You haven't submit your answers for this test!",
      submissionsRefusedNoCredits: "Your institution can't accept further submissions. Please contact your supervisor",
      title:
        "Edulai Skills Checker evaluates the level of some of your key skills, essential for tackling today's job market challenges.",
      description1:
        "We will present you with several concrete professional cases to read carefully. Each case describes a specific situation, and you will need to choose, among the provided answers/solutions, the one you think is most appropriate for that specific case. Don't overthink it. There are no right or wrong answers. They are just different approaches that help us better define your skills.",
      description2:
        'Completing the Skills Checker takes between 15 and 20 minutes. The answers must be provided in the proposed sequence. You cannot skip them or move back and forth between questions. The test must be completed all at once, but if technical issues prevent you from finishing it, you will have the opportunity to log in again and submit the missing answers. Once all responses are completed, the system will show you the results, and you will have access to both a general report and a more specific one on the development of your skills. You will also be provided with guidelines to best interpret the results. The Edulai Skills Checker assessment can be taken once or multiple times over a given period so that the development of one or more skills can be monitored over time.',
      description3:
        "The future of work is now. It's time to unleash your full potential: embrace the challenge, conquer our scenarios, and truly own the soft and digital skills that will make you unstoppable for what's next.",
      question: 'Case',
      options: 'Options',
      option: 'Option',
      all: 'All',
      message_1:
        "Congratulations!<br/> You've already solved the first cases! Keep going and soon you'll know a lot about yourself!",
      message_2:
        "Well done!<br/> You've challenged yourself with these additional cases! It took some attention and personal reflection, but it was totally worth it! Great job! Don’t give up, and soon you’ll see your results!",
      message_3:
        "Now you've passed the halfway mark in your journey!<br/> Not everyone gets this far! Congratulations! You’re showing great consistency and determination! You’re almost there!",
      message_4:
        "Wow!!<br/> You're nearly at the end! Once you finish the test, you'll receive lots of useful suggestions that will help you understand yourself better — without judgment, just with the aim of enhancing your skills!",
      message_end:
        "Huge congratulations!<br/> You’ve reached the end of the journey! What a great achievement! You're amazing! Now you’ll be able to discover your skills one by one (and believe me, not everyone knows theirs) and, above all, know what to do to improve them! You’ve earned a reward for this! You've earned our Edulai digital badge for gaining greater awareness of your skills. Download the PDF badge here.",
      button: 'Forward',
      buttonEnd: 'Show results',
      downloadBadge: 'Download the badge',
      showAllText: 'Show all at once'
    },
    chat: {
      messageError: 'An error occurred, please try again.',
      askAI: 'Ask Edulai Coach AI',
      coachAIMessage: `I am Edulai’s **AI Coach**, and I’m here to help you develop your *skills*.
- Ask me questions about your test results: I can analyze them and show you your strengths, weaknesses, and areas for improvement, including scores, suggestions, and useful comments.
- Ask me how to improve your weaker skills and further enhance your stronger ones: I can provide tips and valuable advice.
- Ask me for reading materials, audio, or video resources to improve your competencies; I can also recommend them based on your current level.`,
      coachAIPrompt:
        "Comment on the quiz results {{ id }}. Don't mention the quiz ID in your answer; please respond even if you've already answered. Reply in {{ language }}",
      retry: 'Send the last question again'
    }
  }
};
